const GENERAL_ICONS = {
  'AccessAlarm': require('./AccessAlarm.svg'),
  'AccessibleForward': require('./AccessibleForwardOutlined.svg'),
  'AccessTime': require('./AccessTime.svg'),
  'AccessTimeFilled': require('./AccessTimeFilledOutlined.svg'),
  'AccountBalance': require('./AccountBalanceOutlined.svg'),
  'AccountBalanceWallet': require('./AccountBalanceWalletOutlined.svg'),
  'AccountBox': require('./AccountBoxOutlined.svg'),
  'AccountCircle': require('./AccountCircleOutlined.svg'),
  'AccountTree': require('./AccountTreeOutlined.svg'),
  'AddAlarm': require('./AddAlarmOutlined.svg'),
  'AddAlert': require('./AddAlertOutlined.svg'),
  'AddAPhoto': require('./AddAPhotoOutlined.svg'),
  'AddBox': require('./AddBoxOutlined.svg'),
  'AddBusiness': require('./AddBusinessOutlined.svg'),
  'AddCard': require('./AddCardOutlined.svg'),
  'AddChart': require('./AddChartOutlined.svg'),
  'AddComment': require('./AddCommentOutlined.svg'),
  'AddIcCall': require('./AddIcCallOutlined.svg'),
  'AddLocationAlt': require('./AddLocationAltOutlined.svg'),
  'AddLocation': require('./AddLocationOutlined.svg'),
  'AddModerator': require('./AddModeratorOutlined.svg'),
  'AddPhotoAlternate': require('./AddPhotoAlternateOutlined.svg'),
  'AddReaction': require('./AddReactionOutlined.svg'),
  'AddRoad': require('./AddRoadOutlined.svg'),
  'AddToHomeScreen': require('./AddToHomeScreenOutlined.svg'),
  'AddToQueue': require('./AddToQueueOutlined.svg'),
  'Adjust': require('./AdjustOutlined.svg'),
  'AdsClick': require('./AdsClickOutlined.svg'),
  'AirlineSeatFlat': require('./AirlineSeatFlatOutlined.svg'),
  'Airlines': require('./AirlinesOutlined.svg'),
  'AirplanemodeActive': require('./AirplanemodeActiveOutlined.svg'),
  'AirplanemodeInactive': require('./AirplanemodeInactiveOutlined.svg'),
  'AirportShuttle': require('./AirportShuttleOutlined.svg'),
  'AlarmOff': require('./AlarmOffOutlined.svg'),
  'AllOut': require('./AllOutOutlined.svg'),
  'AlternateEmail': require('./AlternateEmailOutlined.svg'),
  'Announcement': require('./AnnouncementOutlined.svg'),
  'Apartment': require('./ApartmentOutlined.svg'),
  'AppBlocking': require('./AppBlockingOutlined.svg'),
  'Article': require('./ArticleOutlined.svg'),
  'AssistantPhoto': require('./AssistantPhotoOutlined.svg'),
  'Atm': require('./AtmOutlined.svg'),
  'AttachMoney': require('./AttachMoneyOutlined.svg'),
  'AutoDelete': require('./AutoDeleteOutlined.svg'),
  'Backup': require('./BackupOutlined.svg'),
  'BatteryCharging20': require('./BatteryCharging20Filled.svg'),
  'BatteryChargingFull': require('./BatteryChargingFullOutlined.svg'),
  'Bed': require('./BedOutlined.svg'),
  'Block': require('./BlockOutlined.svg'),
  'Brightness1': require('./Brightness1Outlined.svg'),
  'Brightness1_2': require('./Brightness1Round.svg'),
  'BrowserNotSupported': require('./BrowserNotSupportedOutlined.svg'),
  'BuildCircle': require('./BuildCircleOutlined.svg'),
  'BusinessCenter': require('./BusinessCenterOutlined.svg'),
  'Business': require('./BusinessOutlined.svg'),
  'CalendarMonth': require('./CalendarMonthOutlined.svg'),
  'CallEnd': require('./CallEndOutlined.svg'),
  'CameraAlt': require('./CameraAltOutlined.svg'),
  'CameraIndoor': require('./CameraIndoorOutlined.svg'),
  'CameraOutdoor': require('./CameraOutdoorOutlined.svg'),
  'CameraRoll': require('./CameraRollOutlined.svg'),
  'Campaign': require('./CampaignOutlined.svg'),
  'Cancel': require('./CancelOutlined.svg'),
  'CarRental': require('./CarRentalOutlined.svg'),
  'CatchingPokemon': require('./CatchingPokemonOutlined.svg'),
  'CellTower': require('./CellTowerOutlined.svg'),
  'CheckCircle': require('./CheckCircleOutlined.svg'),
  'ChildCare': require('./ChildCareOutlined.svg'),
  'ChildFriendly': require('./ChildFriendlyOutlined.svg'),
  'CircleNotifications': require('./CircleNotificationsOutlined.svg'),
  'CleaningServices': require('./CleaningServicesOutlined.svg'),
  'CloudDone': require('./CloudDoneOutlined.svg'),
  'CloudDownload': require('./CloudDownloadOutlined.svg'),
  'CloudOff': require('./CloudOffOutlined.svg'),
  'Cloud': require('./CloudOutlined.svg'),
  'CloudUpload': require('./CloudUploadOutlined.svg'),
  'Code': require('./CodeOutlined.svg'),
  'Colorize': require('./ColorizeOutlined.svg'),
  'ColorLens': require('./ColorLensOutlined.svg'),
  'Computer': require('./ComputerOutlined.svg'),
  'Construction': require('./ConstructionOutlined.svg'),
  'ContentCopy': require('./ContentCopyOutlined.svg'),
  'ContentCut': require('./ContentCutOutlined.svg'),
  'ContentPaste': require('./ContentPasteOutlined.svg'),
  'ContentPasteSearch': require('./ContentPasteSearchOutlined.svg'),
  'Cookie': require('./CookieOutlined.svg'),
  'CorporateFare': require('./CorporateFareOutlined.svg'),
  'Cottage': require('./CottageOutlined.svg'),
  'CreditCard': require('./CreditCardOutlined.svg'),
  'CropOriginal': require('./CropOriginalOutlined.svg'),
  'Crop': require('./CropOutlined.svg'),
  'CrueltyFree': require('./CrueltyFreeOutlined.svg'),
  'Dangerous': require('./DangerousOutlined.svg'),
  'DarkMode': require('./DarkModeOutlined.svg'),
  'DashboardCustomize': require('./DashboardCustomizeOutlined.svg'),
  'DataArray': require('./DataArrayOutlined.svg'),
  'DataObject': require('./DataObjectOutlined.svg'),
  'DeleteForever': require('./DeleteForeverOutlined.svg'),
  'Description': require('./DescriptionOutlined.svg'),
  'DesktopAccessDisabled': require('./DesktopAccessDisabledOutlined.svg'),
  'DesktopMac': require('./DesktopMacOutlined.svg'),
  'DeveloperBoard': require('./DeveloperBoardOutlined.svg'),
  'DirectionsBike': require('./DirectionsBikeOutlined.svg'),
  'DirectionsBusFilled': require('./DirectionsBusFilledOutlined.svg'),
  'DirectionsCarFilled': require('./DirectionsCarFilledFilled.svg'),
  'DirectionsCarFilled_2': require('./DirectionsCarFilledOutlined.svg'),
  'DirectionsWalk': require('./DirectionsWalkOutlined.svg'),
  'DirtyLens': require('./DirtyLensOutlined.svg'),
  'DisabledVisible': require('./DisabledVisibleOutlined.svg'),
  'Dns': require('./DnsOutlined.svg'),
  'DomainDisabled': require('./DomainDisabledOutlined.svg'),
  'Domain': require('./DomainOutlined.svg'),
  'DoneOutline': require('./DoneOutlineOutlined.svg'),
  'DoorBack': require('./DoorBackOutlined.svg'),
  'Doorbell': require('./DoorbellOutlined.svg'),
  'Drafts': require('./DraftsOutlined.svg'),
  'DriveEta': require('./DriveEtaOutlined.svg'),
  'DynamicForm': require('./DynamicFormOutlined.svg'),
  'EditLocationAlt': require('./EditLocationAltOutlined.svg'),
  'EditNotifications': require('./EditNotificationsOutlined.svg'),
  'Edit': require('./EditOutlined.svg'),
  'Elderly': require('./ElderlyOutlined.svg'),
  'ElectricalServices': require('./ElectricalServicesOutlined.svg'),
  'ElectricCar': require('./ElectricCarOutlined.svg'),
  'Elevator': require('./ElevatorOutlined.svg'),
  'Email': require('./EmailOutlined.svg'),
  'Emergency': require('./EmergencyOutlined.svg'),
  'EmergencyRecording': require('./EmergencyRecordingOutlined.svg'),
  'EmergencyShare': require('./EmergencyShareOutlined.svg'),
  'EMobiledata': require('./EMobiledataOutlined.svg'),
  'EmojiEmotions': require('./EmojiEmotionsOutlined.svg'),
  'EmojiObjects': require('./EmojiObjectsOutlined.svg'),
  'EmojiPeople': require('./EmojiPeopleOutlined.svg'),
  'EmojiTransportation': require('./EmojiTransportationOutlined.svg'),
  'Engineering': require('./EngineeringOutlined.svg'),
  'EscalatorWarning': require('./EscalatorWarningOutlined.svg'),
  'EventAvailable': require('./EventAvailableOutlined.svg'),
  'ExtensionOff': require('./ExtensionOffOutlined.svg'),
  'Extension': require('./ExtensionOutlined.svg'),
  'Face': require('./FaceOutlined.svg'),
  'FaceRetouchingNatural': require('./FaceRetouchingNaturalOutlined.svg'),
  'FaceRetouchingOff': require('./FaceRetouchingOffOutlined.svg'),
  'FamilyRestroom': require('./FamilyRestroomOutlined.svg'),
  'FavoriteBorder': require('./FavoriteBorderOutlined.svg'),
  'FilterAltOff': require('./FilterAltOffOutlined.svg'),
  'FilterAlt': require('./FilterAltOutlined.svg'),
  'FindInPage': require('./FindInPageOutlined.svg'),
  'FireExtinguisher': require('./FireExtinguisherOutlined.svg'),
  'Flag': require('./FlagOutlined.svg'),
  'FlashOn': require('./FlashOnOutlined.svg'),
  'FlipCameraIos': require('./FlipCameraIosOutlined.svg'),
  'Flood': require('./FloodOutlined.svg'),
  'Folder': require('./FolderOutlined.svg'),
  'Forest': require('./ForestOutlined.svg'),
  'Garage': require('./GarageOutlined.svg'),
  'GetApp': require('./GetAppOutlined.svg'),
  'GppBad': require('./GppBadOutlined.svg'),
  'GppGood': require('./GppGoodOutlined.svg'),
  'GppMaybe': require('./GppMaybeOutlined.svg'),
  'Grade': require('./GradeOutlined.svg'),
  'Gun': require('./Gun.svg'),
  'Handyman': require('./HandymanOutlined.svg'),
  'Headphones': require('./HeadphonesOutlined.svg'),
  'HeadsetMic': require('./HeadsetMicOutlined.svg'),
  'HearingDisabled': require('./HearingDisabledOutlined.svg'),
  'History': require('./HistoryOutlined.svg'),
  'Home': require('./HomeOutlined.svg'),
  'HourglassEmpty': require('./HourglassEmptyOutlined.svg'),
  'HowToReg': require('./HowToRegOutlined.svg'),
  'Https': require('./HttpsOutlined.svg'),
  'InsertEmoticon': require('./InsertEmoticonOutlined.svg'),
  'LocalConvenienceStore': require('./LocalConvenienceStoreOutlined.svg'),
  'LocalFireDepartment': require('./LocalFireDepartmentOutlined.svg'),
  'LocalHospital': require('./LocalHospitalOutlined.svg'),
  'LocalMall': require('./LocalMallOutlined.svg'),
  'LocalShipping': require('./LocalShippingOutlined.svg'),
  'LocationCity': require('./LocationCityOutlined.svg'),
  'LogOut': require('./LogOutOutlined.svg'),
  'Map': require('./MapOutlined.svg'),
  'Masks': require('./MasksOutlined.svg'),
  'MeetingRoom': require('./MeetingRoomOutlined.svg'),
  'NotificationsActive': require('./NotificationsActiveOutlined.svg'),
  'NotificationsNone': require('./NotificationsNoneOutlined.svg'),
  'OfflineBolt': require('./OfflineBoltOutlined.svg'),
  'OndemandVideo': require('./OndemandVideoOutlined.svg'),
  'Paid': require('./PaidOutlined.svg'),
  'PeopleOutline': require('./PeopleOutlineFilled.svg'),
  'Pets': require('./PetsOutlined.svg'),
  'PhonelinkRing': require('./PhonelinkRingOutlined.svg'),
  'PhoneMissed': require('./PhoneMissedOutlined.svg'),
  'PhotoCamera': require('./PhotoCameraOutlined.svg'),
  'PriceChange': require('./PriceChangeOutlined.svg'),
  'Public': require('./PublicOutlined.svg'),
  'QuestionMark': require('./QuestionMarkOutlined.svg'),
  'ReportProblem': require('./ReportProblemOutlined.svg'),
  'RocketLaunch': require('./RocketLaunchOutlined.svg'),
  'Rocket': require('./RocketOutlined.svg'),
  'RoomPreferences': require('./RoomPreferencesOutlined.svg'),
  'RoomService': require('./RoomServiceOutlined.svg'),
  'RunCircle': require('./RunCircleOutlined.svg'),
  'SafetyDivider': require('./SafetyDividerOutlined.svg'),
  'SaveAll': require('./SaveAllOutlined.svg'),
  'Save': require('./SaveOutlined.svg'),
  'Science': require('./ScienceOutlined.svg'),
  'Send': require('./SendOutlined.svg'),
  'SentimentDissatisfied': require('./SentimentDissatisfiedOutlined.svg'),
  'SentimentNeutral': require('./SentimentNeutralOutlined.svg'),
  'SentimentSatisfied': require('./SentimentSatisfiedOutlined.svg'),
  'SentimentVeryDissatisfied': require('./SentimentVeryDissatisfiedOutlined.svg'),
  'SentimentVerySatisfied': require('./SentimentVerySatisfiedOutlined.svg'),
  'SmartToy': require('./SmartToyOutlined.svg'),
  'SpatialAudioOff': require('./SpatialAudioOffOutlined.svg'),
  'SpatialTracking': require('./SpatialTrackingOutlined.svg'),
  'Speaker': require('./SpeakerOutlined.svg'),
  'Speed': require('./SpeedOutlined.svg'),
  'StarBorder': require('./StarBorderOutlined.svg'),
  'Star': require('./StarOutlined.svg'),
  'Thermostat': require('./ThermostatOutlined.svg'),
  'ThumbDownAlt': require('./ThumbDownAltOutlined.svg'),
  'ThumbUp': require('./ThumbUpOutlined.svg'),
  'Thunderstorm': require('./ThunderstormOutlined.svg'),
  'VideoCameraBack': require('./VideoCameraBackOutlined.svg'),
  'VideoCameraFront': require('./VideoCameraFrontOutlined.svg'),
  'VideocamOff': require('./VideocamOffOutlined.svg'),
  'Videocam': require('./VideocamOutlined.svg'),
  'VideoSettings': require('./VideoSettingsOutlined.svg'),
  'ViewModule': require('./ViewModuleOutlined.svg'),
  'ViewQuilt': require('./ViewQuiltOutlined.svg'),
  'ViewSidebar': require('./ViewSidebarOutlined.svg'),
  'VisibilityOff': require('./VisibilityOffOutlined.svg'),
  'Visibility': require('./VisibilityOutlined.svg'),
  'VolumeDown': require('./VolumeDownOutlined.svg'),
  'VolumeMute': require('./VolumeMuteOutlined.svg'),
  'WbCloudy': require('./WbCloudyOutlined.svg'),
  'Whatshot': require('./WhatshotOutlined.svg'),
  'DragArrow': require('./DragArrow.svg'),
}

// Iconos del sector bancario (sección "bank")
const BANK_ICONS = {
  'AccesoOficina_Boveda_ATM': require('./AccesoOficina_Boveda_ATM.svg'),
  'AlarmaManual': require('./AlarmaManual.svg'),
  'AlarmaManualEnActivacion': require('./AlarmaManualEnActivacion.svg'),
  'Amago_Panico_Amago': require('./Amago_Panico_Amago.svg'),
  'ArmadoConAutoprotector': require('./ArmadoConAutoprotector.svg'),
  'ArmadoGruposEnActivacion': require('./ArmadoGruposEnActivacion.svg'),
  'ArmadoTodosLosGrupos': require('./ArmadoTodosLosGrupos.svg'),
  'Asalto_Atraco': require('./Asalto_Atraco.svg'),
  'AudiovisualComando': require('./AudiovisualComando.svg'),
  'AudiovisualComandoEnActivacion': require('./AudiovisualComandoEnActivacion.svg'),
  'BateriaPanelDMP': require('./BateriaPanelDMP.svg'),
  'BateriaPanelDMPEnActivacion': require('./BateriaPanelDMPEnActivacion.svg'),
  'CanonDeNiebla': require('./CanonDeNiebla.svg'),
  'Comunicacion': require('./Comunicacion.svg'),
  'ComunicacionEquipoEnActivacion': require('./ComunicacionEquipoEnActivacion.svg'),
  'ComunicacionEquipoEnByPass': require('./ComunicacionEquipoEnByPass.svg'),
  'DiasDeGrabacion': require('./DiasDeGrabacion.svg'),
  'DiferenciaHoraCCTEnActivacion': require('./DiferenciaHoraCCTEnActivacion.svg'),
  'DiferenciaHoraPanel': require('./DiferenciaHoraPanel.svg'),
  'DiferenciaHoraPanelEnActivacion': require('./DiferenciaHoraPanelEnActivacion.svg'),
  'DiferenciaHorariaCCTV': require('./DiferenciaHorariaCCTV.svg'),
  'ErrorOperativo': require('./ErrorOperativo.svg'),
  'EsclusaComando': require('./EsclusaComando.svg'),
  'EstadoBateriaDispositivoEnActivacion': require('./EstadoBateriaDispositivoEnActivacion.svg'),
  'EstadoBateriaDispositivoInalambrico': require('./EstadoBateriaDispositivoInalambrico.svg'),
  'FallaDisco': require('./FallaDisco.svg'),
  'FallaEnEnergia': require('./FallaEnEnergia.svg'),
  'FallaVentilador': require('./FallaVentilador.svg'),
  'Grupos': require('./Grupos.svg'),
  'GruposEnActivacion': require('./GruposEnActivacion.svg'),
  'Incendio': require('./Incendio.svg'),
  'Intrusion_SupervisionRDMP': require('./Intrusion_SupervisionRDMP.svg'),
  'IntrusionATM': require('./IntrusionATM.svg'),
  'LiberacionDePuertaEsclusa': require('./LiberacionDePuertaEsclusa.svg'),
  'PerdidaDeVideo': require('./PerdidaDeVideo.svg'),
  'PersonalTecnico': require('./PersonalTecnico.svg'),
  'ResetPanelDMP': require('./ResetPanelDMP.svg'),
  'ResetPanelDMPEnActivacion': require('./ResetPanelDMPEnActivacion.svg'),
  'SirenaComando': require('./SirenaComando.svg'),
  'TestPanelDMP': require('./TestPanelDMP.svg'),
  'TestPanelDMPEnActivacion': require('./TestPanelDMPEnActivacion.svg'),
  'TodaFallaDeCCTEnActivacion': require('./TodaFallaDeCCTEnActivacion.svg'),
  'TodaFallaDeCCTV': require('./TodaFallaDeCCTV.svg'),
  'UsuarioSinUso': require('./UsuarioSinUso.svg'),
  'UsuarioSinUsuEnActivacion': require('./UsuarioSinUsuEnActivacion.svg'),
}

const ICONS = { ...GENERAL_ICONS, ...BANK_ICONS }

// Lista de nombres de iconos disponibles (útil para selectores/dropdowns)
export const ICON_NAMES = Object.keys(ICONS)

// Solo iconos del sector bancario (sección "bank"), usado en el selector de Reglas DMP
export const BANK_ICON_NAMES = Object.keys(BANK_ICONS)

export default ICONS
